/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SummaryProductRejectedFromJSON, SummaryProductRejectedToJSON, } from './SummaryProductRejected';
/**
 * Check if a given object implements the SummaryInfo interface.
 */
export function instanceOfSummaryInfo(value) {
    let isInstance = true;
    isInstance = isInstance && "sampleProductsRejected" in value;
    isInstance = isInstance && "totalProducts" in value;
    isInstance = isInstance && "totalProductsImported" in value;
    isInstance = isInstance && "totalProductsRejected" in value;
    return isInstance;
}
export function SummaryInfoFromJSON(json) {
    return SummaryInfoFromJSONTyped(json, false);
}
export function SummaryInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sampleProductsRejected': (json['sample_products_rejected'].map(SummaryProductRejectedFromJSON)),
        'totalProducts': json['total_products'],
        'totalProductsImported': json['total_products_imported'],
        'totalProductsRejected': json['total_products_rejected'],
    };
}
export function SummaryInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sample_products_rejected': (value.sampleProductsRejected.map(SummaryProductRejectedToJSON)),
        'total_products': value.totalProducts,
        'total_products_imported': value.totalProductsImported,
        'total_products_rejected': value.totalProductsRejected,
    };
}
